import CRM from "../assets/images/CRM.jpeg"
import IVR from "../assets/images/IVR.webp"
import WFM from "../assets/images/WFM.webp"
import chat_assistant from "../assets/images/Chat-Assistant.jpeg"
import call_center from "../assets/images/modem.png"

const CallByProjects = [
    {
        company: "Arkenom Tech",
        year: "2015",
        title: "Smart CRM for the Best Customer Experiences",
        results: [
            {"title": "Engage Smarter: All customer interactions in one smart platform"},
            {"title": "Simplify Payments: Automated billing, secure and flexible payment options"},
            {"title": "Empower Customers: Easy service requests, real-time tracking"},
            {"title": "Drive Decisions: Actionable insights powered by data analytics"}
        ],
        image: CRM,
    },
    {
        company: "Arkenom Tech",
        year: "2015",
        title: "Intelligent Call Center Solutions for Seamless Customer Engagement",
        results: [
            {"title": "AI-Powered Call Handling: Automate routine calls and reduce agent workload with smart self-service"},
            {"title": "Personalized Experiences: Respond dynamically with insights from caller history"},
            {"title": "Omnichannel Integration: Unify voice, SMS, email, and chatbot support on a single platform"},
            {"title": "Real-Time Analytics: Track performance live and optimize your operations instantly"},
        ],
        image: IVR,
    },
    {
        company: "Arkenom Tech",
        year: "2015",
        title: "Empower Your Workforce. Maximize Your Impact",
        results: [
            {"title": "Right People, Right Time: AI-powered smart scheduling that keeps your teams one step ahead"},
            {"title": "Do More with Less: Automate repetitive tasks and boost productivity effortlessly"},
            {"title": "See. Act. Improve.: Track performance live, optimize instantly"},
            {"title": "Cut Costs. Boost Results.: Turn data into smarter, leaner operations"}
        ],
        image: WFM,
    },
    {
        company: "Arkenom Tech",
        year: "2015",
        title: "AI-Powered Solutions for Smarter Customer Management",
        results: [
            {"title": "Handle Every Interaction: Seamlessly manage voice, chat, email, and all customer channels with AI-driven automation"},
            {"title": "Instant Process Management: Automate and manage business operations in seconds, increasing speed and efficiency"},
            {"title": "No Call, No Cost: When there’s no call, there’s no cost—AI handles routine needs digitally, cutting expenses especially during off-peak times"},
            {"title": "Smarter Engagement, Happier Customers: Deliver faster, smarter, and more satisfying customer experiences across every touchpoint"}
        ],
        image: chat_assistant,
    },
    {
        company: "Arkenom Tech",
        year: "2015",
        title: "AMR-Compatible IoT Modem",
        results: [
            {"title": "MQTT Compatible: Fully supports MQTT protocol for seamless IoT integration"},
            {"title": "MASS Certified: Compliant with industry standards for secure and reliable operations"},
            {"title": "100% Arkenom Innovation: Fully designed and manufactured by Arkenom Technology R&D Department"}
        ],
        image: call_center,
    }
];

export const ProjectsSection = () => {
    return(
        <section className="pb-14">
            <div className="w-full bg-gradient-to-b from-[#5e8b9b] via-[#095369] to-[#001a22] text-white py-14 px-6">
                <div className="max-w-7xl mx-auto text-center">
                    <p className="font-segoe-ui uppercase font-semibold text-xs sm:text-base tracking-widest bg-gradient-to-r from-gray-50 to-gray-500 text-center bg-clip-text text-transparent">
                        Real-world Results
                    </p>
                </div>
                <h2 className="font-segoe-ui text-3xl font-semibold mb-10 md:text-5xl text-center mt-3 sm:mt-6">
                    Arkenom Technology
                </h2>
                <p className="font-segoe-ui text-center text-xs lg:text-base text-gray-100 mt-4 mb-4 max-w-full sm:max-w-6xl mx-auto w-full">
                    Arkenom Technology provides specialized technological solutions and services to utility companies, including CRM, WFM, Call Center, and AI solutions. Backed by a strong software development and dedicated support team, it delivers AI-powered solutions tailored to meet the specific needs of its clients.
                </p>
            </div>
        </section>
    );
};